// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Tickets_UpdateticketResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Tickets_UpdateticketResponseDados {
ID: number
Titulo: string
Prioridade: number
Descricao: string
Usuario: string
CategoriaID: number
created_at?: string
updated_at?: string
}

export type Tickets_UpdateticketResponse = ApiResponse<Tickets_UpdateticketResponseDados>;

registerResponseContract('Tickets_UpdateticketResponse', {
  ID:          { type: 'number',  required: true },
  Titulo:      { type: 'string',  required: true },
  Prioridade:  { type: 'number',  required: true },
  Descricao:   { type: 'string',  required: true },
  Usuario:     { type: 'string',  required: true },
  CategoriaID: { type: 'number',  required: true },
  created_at:  { type: 'string',  required: false },
  updated_at:  { type: 'string',  required: false },
})
